import React from 'react';
import { Modal, Table } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { hideSoftDeleteConflict } from 'store/slices/softDeleteSlice';
import { confirmSoftDelete, cancelSoftDelete } from 'services/baseQueryWith409';

const SoftDeleteConflictModal = ({ onConfirmForce }) => {
	const dispatch = useDispatch();
	const { isOpen, requestId, request, entityId, conflict } = useSelector(
		state => state.softDelete
	);

	const handleCancel = () => {
		if (requestId) cancelSoftDelete(requestId);
		dispatch(hideSoftDeleteConflict());
	};
	const handleOk = async () => {
		if (requestId) await confirmSoftDelete(requestId);
		dispatch(hideSoftDeleteConflict());
		// optional external callback
		onConfirmForce?.({ request, entityId, conflict });
	};

	return (
		<Modal
			title='Este elemento tiene dependencias'
			open={isOpen}
			okText='Eliminar igualmente'
			okType='danger'
			cancelText='Cancelar'
			onCancel={handleCancel}
			onOk={handleOk}
			destroyOnClose
		>
			<p>
				Se encontraron elementos relacionados que dependen de este registro.
				Si continúa, se forzará la eliminación lógica.
			</p>
			{entityId ? (
				<p>
					ID del elemento: <b>{entityId}</b>
				</p>
			) : null}
			{conflict?.details?.length ? (
				<Table
					size='small'
					pagination={false}
					rowKey={(row, idx) => idx}
					columns={[
						{ title: 'Tipo', dataIndex: 'type' },
						{ title: 'Campo', dataIndex: 'field' },
						{ title: 'Cantidad', dataIndex: 'count' },
					]}
					dataSource={conflict.details}
				/>
			) : null}
		</Modal>
	);
};

export default SoftDeleteConflictModal;
